var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// source/assets/color-swatches.js
var ColorSwatch = class extends HTMLElement {
  constructor() {
    super();
    this.cached = {};
    this.variantId = this.dataset.variantId;
    this.container = this.closest(".card-wrapper");
    if (this.variantId || theme.config.mqlSmall) {
      this.addEventListener("mouseenter", this.onHoverHandler.bind(this));
      this.querySelector("a").addEventListener(
        "click",
        (event) => event.preventDefault()
      );
    } else {
      this.addEventListener("mouseenter", this.onHoverHandler.bind(this));
    }
  }
  onHoverHandler() {
    if (this.variantId) {
      theme.config.mqlSmall || theme.config.isTouch ? this.colorSwatchChange() : this.colorSwatchFetch();
    } else {
      this.colorSwatchChange();
    }
  }
  colorSwatchChange(forceUpdate) {
    const image = this.container.querySelector(
      ".card--image-animate.media img"
    );
    const pictureSource = this.container.querySelector(
      ".card--image-animate.media source"
    );
    if (image !== null || pictureSource != null || forceUpdate) {
      if (image !== null) {
        image.src = this.dataset.src;
        image.srcset = this.dataset.srcset;
      }
      if (pictureSource !== null) {
        pictureSource.srcset = this.dataset.srcset;
      }
      const swatches = this.container.querySelectorAll(".color-swatch");
      swatches.forEach((swatch) => {
        swatch.classList.remove("is-active");
      });
      this.classList.add("is-active");
      this.container.querySelector(".card--image-animate.media").style.display = "block";
      if (this.container.querySelector(".card-media-video"))
        this.container.querySelector(".card-media-video").style.display = "none";
    }
  }
  colorSwatchFetch() {
    const productHandle = this.dataset.productHandle;
    const collectionHandle = this.dataset.collectionHandle;
    let sectionUrl = `${theme.routes.root_url}/products/${productHandle}?variant=${this.variantId}&view=card`;
    if (collectionHandle.length > 0) {
      sectionUrl = `${theme.routes.root_url}/collections/${collectionHandle}/products/${productHandle}?variant=${this.variantId}&view=card`;
    }
    sectionUrl = sectionUrl.replace("//", "/");
    if (this.cached[sectionUrl]) {
      this.renderProductInfo(this.cached[sectionUrl]);
      return;
    }
    fetch(sectionUrl).then((response) => response.text()).then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      this.cached[sectionUrl] = html;
      this.renderProductInfo(html);
    }).catch((e) => {
      console.error(e);
    });
  }
  renderProductInfo(html) {
    this.updateButtons(html);
    this.updateTitle(html);
    this.updatePrice(html);
    this.colorSwatchChange(true);
  }
  updateTitle(html) {
    const selector = ".card-information__text";
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination)
      destination.innerHTML = source.innerHTML + "<small>&ndash;&nbsp;" + this.getAttribute("title") + "</small>";
  }
  updatePrice(html) {
    if (html.querySelector("color-swatch-radios")) return;
    const selector = ".price";
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }
  updateButtons(html) {
    const selector = ".card-information__button";
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination) destination.innerHTML = source.innerHTML;
    destination.classList.remove("is-expanded");
    if (source.classList.contains("is-expanded"))
      destination.classList.add("is-expanded");
  }
};
customElements.define("color-swatch", ColorSwatch);
var ColorSwatchRadios = class extends HTMLElement {
  constructor() {
    super();
    this.classes = {
      soldOut: "price--sold-out",
      onSale: "price--on-sale",
      noCompare: "price--no-compare",
      hidden: "hidden",
      loading: "loading"
    };
    this.selectors = {
      cardWrapper: ".card-wrapper",
      priceWrapper: ".price",
      price: ".price__regular .price-item--regular",
      comparePrice: ".price__sale .price-item--regular",
      salePrice: ".price__sale .price-item--sale",
      unitWrapper: ".unit-price",
      unitPrice: "[data-unit-price]",
      unitPriceBaseUnit: "[data-unit-base]"
    };
    this.miniCart = document.querySelector("mini-cart");
    this.init();
    this.addEventListener("change", this.onVariantChange);
    const buttons = this.querySelectorAll(".swatch:not(.disabled)");
    buttons.forEach(
      (button) => button.addEventListener("mouseenter", this.onEnterHandler.bind(this))
    );
    buttons.forEach(
      (button) => button.addEventListener("mouseleave", this.onLeaveHandler.bind(this))
    );
    const inputs = this.querySelectorAll(".swatch:not(.disabled) input");
    inputs.forEach(
      (input) => input.addEventListener("click", this.onClickHandler.bind(this))
    );
  }
  cacheElements() {
    this.container = this.closest(this.selectors.cardWrapper);
    this.cache = {
      priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
      price: this.container.querySelector(this.selectors.price),
      comparePrice: this.container.querySelector(this.selectors.comparePrice),
      salePrice: this.container.querySelector(this.selectors.salePrice),
      priceHTML: this.container.querySelector(this.selectors.priceWrapper).cloneNode(true).innerHTML,
      priceClass: this.container.querySelector(this.selectors.priceWrapper).cloneNode(true).getAttribute("class")
    };
  }
  onClickHandler(event) {
    const input = event.currentTarget;
    const button = input.parentNode;
    const variantId = this.currentVariant.id;
    if (variantId) {
      if (document.body.classList.contains("template-cart") || !theme.shopSettings.cartDrawer) {
        Shopify.postLink(theme.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1
          }
        });
        return;
      }
      input.setAttribute("disabled", "");
      button.classList.add(this.classes.loading);
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections,
        sections_url: window.location.pathname
      });
      fetch(`${theme.routes.cart_add_url}`, __spreadProps(__spreadValues({}, fetchConfig("javascript")), {
        body
      })).then((response) => response.json()).then((parsedState) => {
        this.miniCart && this.miniCart.renderContents(parsedState);
      }).catch((e) => {
        console.error(e);
      }).finally(() => {
        input.removeAttribute("disabled");
        button.classList.remove(this.classes.loading);
      });
    }
  }
  onEnterHandler(event) {
    const target = event.currentTarget;
    const input = target.querySelector("input");
    input.checked = true;
    this.dispatchEvent(new Event("change"));
    setTimeout(() => {
      this.cacheElements();
      this.updatePrice();
      this.updateUnitPrice();
    });
  }
  onLeaveHandler() {
    this.cache.priceWrapper.innerHTML = this.cache.priceHTML;
    this.cache.priceWrapper.setAttribute("class", this.cache.priceClass);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
  }
  init() {
    this.updateOptions();
    this.updateMasterId();
    this.setAvailability();
  }
  updatePrice() {
    const variant = this.currentVariant;
    if (variant) {
      this.cache.priceWrapper.classList.remove(this.classes.soldOut);
      this.cache.priceWrapper.classList.remove(this.classes.onSale);
      this.cache.priceWrapper.classList.remove(this.classes.noCompare);
      if (variant.available == false) {
        this.cache.priceWrapper.classList.add(this.classes.soldOut);
      } else if (variant.compare_at_price > variant.price) {
        this.cache.priceWrapper.classList.add(this.classes.onSale);
      }
      this.cache.price.innerHTML = "<price-money><bdi>" + theme.Currency.formatMoney(
        variant.price,
        theme.shopSettings.moneyFormat
      ) + "</bdi></price-money>";
      if (variant.compare_at_price > variant.price) {
        this.cache.comparePrice.innerHTML = "<price-money><bdi>" + theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.shopSettings.moneyFormat
        ) + "</bdi></price-money>";
        this.cache.salePrice.innerHTML = "<price-money><bdi>" + theme.Currency.formatMoney(
          variant.price,
          theme.shopSettings.moneyFormat
        ) + "</bdi></price-money>";
      } else {
      }
    }
  }
  updateUnitPrice() {
    const variant = this.currentVariant;
    if (this.container.querySelector(this.selectors.unitWrapper)) {
      if (variant && variant.unit_price) {
        this.container.querySelector(this.selectors.unitPrice).innerHTML = "<price-money><bdi>" + theme.Currency.formatMoney(
          variant.unit_price,
          theme.shopSettings.moneyFormat
        ) + "</bdi></price-money>";
        this.container.querySelector(
          this.selectors.unitPriceBaseUnit
        ).innerHTML = theme.Currency.getBaseUnit(variant);
        this.container.querySelector(this.selectors.unitWrapper).classList.remove(this.classes.hidden);
      } else {
        this.container.querySelector(this.selectors.unitWrapper).classList.add(this.classes.hidden);
      }
    }
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
  updateMasterId() {
    var _a;
    this.currentVariant = (_a = this.getVariantData()) == null ? void 0 : _a.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  setAvailability() {
    if (!this.currentVariant) return;
    this.querySelectorAll(".variant-input-wrapper").forEach((group) => {
      this.disableVariantGroup(group);
    });
    const currentlySelectedValues = this.currentVariant.options.map(
      (value, index) => {
        return { value, index: `option${index + 1}` };
      }
    );
    const initialOptions = this.createAvailableOptionsTree(
      this.variantData,
      currentlySelectedValues,
      this.currentVariant
    );
    for (var [option, values] of Object.entries(initialOptions)) {
      this.manageOptionState(option, values);
    }
  }
  enableVariantOption(group, obj) {
    const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
    const input = group.querySelector(
      'input[data-option-value="' + value + '"]'
    );
    if (!input) return;
    input.removeAttribute("disabled");
    input.parentNode.classList.remove("disabled");
    if (obj.soldOut) {
      input.setAttribute("disabled", "");
      input.parentNode.classList.add("disabled");
    }
  }
  disableVariantGroup(group) {
    group.querySelectorAll("input").forEach((input) => {
      input.setAttribute("disabled", "");
      input.parentNode.classList.add("disabled");
    });
  }
  manageOptionState(option, values) {
    const group = this.querySelector(
      '.variant-input-wrapper[data-option-index="' + option + '"]'
    );
    values.forEach((obj) => {
      this.enableVariantOption(group, obj);
    });
  }
  createAvailableOptionsTree(variants, currentlySelectedValues) {
    return variants.reduce(
      (options, variant) => {
        Object.keys(options).forEach((index) => {
          if (variant[index] === null) return;
          let entry = options[index].find(
            (option) => option.value === variant[index]
          );
          if (typeof entry === "undefined") {
            entry = { value: variant[index], soldOut: true };
            options[index].push(entry);
          }
          const currentOption1 = currentlySelectedValues.find(
            ({ value, index: index2 }) => index2 === "option1"
          );
          const currentOption2 = currentlySelectedValues.find(
            ({ value, index: index2 }) => index2 === "option2"
          );
          switch (index) {
            case "option1":
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              break;
            case "option2":
              if (currentOption1 && variant["option1"] === currentOption1.value) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
            case "option3":
              if (currentOption1 && variant["option1"] === currentOption1.value && currentOption2 && variant["option2"] === currentOption2.value) {
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
              }
          }
        });
        return options;
      },
      { option1: [], option2: [], option3: [] }
    );
  }
};
customElements.define("color-swatch-radios", ColorSwatchRadios);
//# sourceMappingURL=color-swatches.js.map
